import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterAHASS from '../components/MasterAHASS';

const MasterAHASSPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterAHASS user={user} />;
};

export default MasterAHASSPage;
